/*
 * Copyright (c) 2020.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Nikita Tropin <ntropin@yandex.ru>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnInit,
  QueryList,
  ViewChildren
} from '@angular/core';
import {FormControl} from '@angular/forms';
import {BaseComponent, CrmIssue, CrmIssueElastic, FileService} from 'compob2b-libs';
import {MAT_AUTOCOMPLETE_SCROLL_STRATEGY_FACTORY_PROVIDER, MatAutocompleteSelectedEvent} from '@angular/material/autocomplete';
import {debounceTime, distinctUntilChanged, filter, takeUntil, tap} from 'rxjs/operators';
import {MAT_SELECT_SCROLL_STRATEGY_PROVIDER} from '@angular/material/select';
import {TaskLinkSearchStore} from './task-link-search.store';
import {NbPopoverDirective} from '@nebular/theme';
import {TaskLinkStore} from './task-link.store';

@Component({
    selector: 'app-task-links-issue',
    templateUrl: './task-links-issue.component.html',
    styleUrls: ['./task-links-issue.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        MAT_AUTOCOMPLETE_SCROLL_STRATEGY_FACTORY_PROVIDER,
        MAT_SELECT_SCROLL_STRATEGY_PROVIDER,
    ],
    standalone: false
})
export class TaskLinksIssueComponent extends BaseComponent implements OnInit, OnChanges, AfterViewInit {

  @Input() issue: CrmIssue;
  @Input() showForm: boolean;
  showComponent = false;
  tasks: CrmIssueElastic[] = [];
  control: FormControl = new FormControl();

  @ViewChildren(NbPopoverDirective) popovers: QueryList<NbPopoverDirective>;

  constructor(private readonly fileService: FileService,
              public readonly searchStore: TaskLinkSearchStore,
              public readonly store: TaskLinkStore) {
    super();
  }

  ngAfterViewInit(): void {
    this.store.load(this.issue.id);
  }

  ngOnInit(): void {
    this.control.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      filter(term => (term !== null && term.length > 1)),
      tap((term: string) => this.searchStore.search(term)),
      takeUntil(this.unsubscribe)
    ).subscribe();
  }

  ngOnChanges(): void {
    if (this.showForm) {
      this.openForm();
    }
  }

  closeForm() {
    this.control.patchValue(null);
    this.tasks.length = 0;
    this.showForm = false;
    this.cdr.detectChanges();
  }

  openForm() {
    this.showComponent = true;
    this.showForm = true;
    this.cdr.detectChanges();
    this.searchStore.searchLast();
  }

  onSubmit() {
    this.store.store(this.issue.id, [...this.tasks]);
    this.tasks.length = 0;
    this.showForm = false;
    this.cdr.detectChanges();
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    const index = this.tasks.findIndex(item => item.id === event.option.value.id);
    if (index === -1) {
      this.tasks.push(event.option.value);
    }

    this.control.setValue(null);
    this.searchStore.reset();
    this.cdr.detectChanges();
  }

  remove(task: CrmIssueElastic) {
    const index = this.tasks.findIndex(item => item.id === task.id);

    if (index !== -1) {
      this.tasks.splice(index, 1);
    }
  }

  removeAll() {
    this.tasks.length = 0;
  }

  getImageUri(picture: string, width: number = 96) {
    return picture === null ? null : this.fileService.getImageSrc(picture, width);
  }

}
